export default "<div class=\"public-container\">\n  <ng-content></ng-content>\n</div>\n";